import { NextPage } from 'next'
import Cookies from 'js-cookie'
import { useEffect } from 'react'
import dynamic from 'next/dynamic'
import { MetaTags } from '@root/layouts'
import { useRemoteConfig } from '@root/hooks'
import { REMOTE_CONFIG_FEATURE_FLAG } from '@root/constants'
import PlaceholderLoader from '@root/components/Loader/PlaceholderLoader'
import { segmentApi } from '@root/api'

const IamSignUpPage = dynamic(() =>
  import('@root/experiences/IAM/SignUpPage').then((mod) => mod)
)
const OnboardingGuestLayout = dynamic(() =>
  import('@root/layouts').then((mod) => mod.OnboardingGuestLayout)
)
const SignUp = dynamic(() =>
  import('@root/experiences/Onboarding/Lite/SignUp').then((mod) => mod.SignUp)
)

const renderPage = (iamSignUpRedirect: boolean | undefined): JSX.Element => {
  if (iamSignUpRedirect) {
    return <IamSignUpPage flow="organic" />
  }

  return (
    <>
      <MetaTags title="Sign Up" />
      <OnboardingGuestLayout>
        <SignUp />
      </OnboardingGuestLayout>
    </>
  )
}

const SignUpPage: NextPage = () => {
  const { treatment, status } = useRemoteConfig(
    REMOTE_CONFIG_FEATURE_FLAG.IAM.signupRollout
  )

  const enableIamSignUp = Cookies.get('enable_iam_signup')
  const iamSignUpRedirect = (): boolean | undefined => {
    if (enableIamSignUp !== undefined) {
      return enableIamSignUp === 'true'
    }
    return treatment?.asBoolean()
  }

  useEffect(() => {
    if (status === 'success') {
      segmentApi.trackWithOSPlatform('ob_firebase_treatment', {
        treatment: treatment?.asBoolean() ? 'ON' : 'OFF',
        name: REMOTE_CONFIG_FEATURE_FLAG.IAM.signupRollout,
      })
    }
  }, [status])

  return status === 'loading' ? (
    <>
      <MetaTags title="Sign Up" />
      <div className="signup-page">
        <PlaceholderLoader />
      </div>
    </>
  ) : (
    renderPage(iamSignUpRedirect())
  )
}

export default SignUpPage
